import { Divider, Utils } from '@treezor/design-system';
import { clsx } from 'clsx';
import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export interface IPairDataProps {
  id?: string;
  data: { [key: string]: string | ReactNode };
  wrapperClassName?: string;
  linkingText?: string | ReactNode;
  hasSeparator?: boolean;
  className?: string;
  keyClassName?: string;
  valueClassName?: string;
}

export const PairData = ({
  id,
  data,
  wrapperClassName,
  linkingText,
  keyClassName,
  valueClassName,
  className,
  hasSeparator,
}: IPairDataProps) => {
  return (
    <div className={className}>
      {Object.entries(data).map(([key, value]) => (
        <span key={key} className={clsx(wrapperClassName, 'flex mb-2')}>
          <div className={twMerge('text-secondary typo-body-bold-small', keyClassName)}>{key}</div>
          {linkingText}
          <div
            className={twMerge('text-secondary typo-body-regular-small min-w-1/4 ml-auto', valueClassName)}
            data-testid={`pairData-${id || Utils.handleTestIdsFormat(key)}`}
          >
            {value}
          </div>
        </span>
      ))}
      {hasSeparator && <Divider />}
    </div>
  );
};
